import type { AxiosRequestConfig } from 'axios'
import type { IAsset, IAssetCreate, IAssetTag, IAssetUpdate } from '~/types/assets-management'

import config from '~/config'
import { request } from '~/utils/request'

export const getAssets = (params?: AxiosRequestConfig['params']): Promise<IPaginatedResponse<IAsset>> => {
  return request({
    params,
    url: `${config.ASSET_MANAGER_API}/v2/assets`,
  })
}

export const getAsset = (id: string): Promise<IAsset> => {
  return request({
    url: `${config.ASSET_MANAGER_API}/v2/assets/${id}`,
  })
}

export const createAsset = (data: IAssetCreate): Promise<void> => {
  return request({
    data,
    method: 'POST',
    url: `${config.ASSET_MANAGER_API}/v2/assets`,
  })
}

export const updateAsset = (data: IAssetUpdate): Promise<void> => {
  return request({
    data,
    method: 'PUT',
    url: `${config.ASSET_MANAGER_API}/v2/assets/${data.id}`,
  })
}

export const batchAssetStatusUpdate = (data: { assets_status: { [key: string]: string } }): Promise<void> => {
  return request({
    data: JSON.stringify(data),
    method: 'POST',
    url: `${config.ASSET_MANAGER_API}/v2/assets/bulk/status`,
  })
}

export const batchAssetTagsUpdate = (data: {
  assets_tags: { [key: string]: Omit<IAssetTag, 'asset_id'>[] }
}): Promise<void> => {
  return request({
    data: JSON.stringify(data),
    method: 'POST',
    url: `${config.ASSET_MANAGER_API}/v2/assets/bulk/tags`,
  })
}

export const getTagsKeys = (): Promise<string[]> => {
  return request({
    url: `${config.ASSET_MANAGER_API}/v2/tags/keys`,
  })
}

export const searchAssets = (query: string): Promise<IPaginatedResponse<IAsset>> => {
  return request({
    data: {
      query,
    },
    method: 'POST',
    url: `${config.ASSET_MANAGER_API}/v2/assets-search`,
  })
}
